import React, { useState } from 'react';
import { LockOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Divider, Popover } from 'antd';
import { useAuthStore } from '../../store';
import ResetPassword from '../ResetPassword';

const Profile = () => {
  const { user, logout } = useAuthStore();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleCloseResetPasswordModal = () => {
    setIsModalVisible(false);
  };

  const handleChangePassword = () => {
    setIsModalVisible(true);
  };

  const content = (
    <div className={'w-[250px]'}>
      <div className={'flex'}>
        <div className={'w-1/4'}>
          <Avatar size="large" icon={<UserOutlined />} />
        </div>
        <div className={'w-3/4'}>
          <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
            {user?.firstName} {user?.lastName}
          </p>
          <p>{user?.email}</p>
          <div>
            <p
              className={
                'p-1 bg-green-500 rounded inline-block text-white font-semibold'
              }
            >
              {user?.role.replace('ROLE_', '')}
            </p>
          </div>
        </div>
      </div>
      <Divider style={{ margin: '8px 0' }} />
      <div>
        <p className={'text-base'}>
          Department:{' '}
          <span className={'font-semibold'}>
            {user?.department?.description}
          </span>
        </p>
      </div>
      <Divider style={{ margin: '8px 0' }} />
      <div>
        <p
          className={
            'text-base cursor-pointer items-center text-blue-500 block'
          }
          onClick={handleChangePassword}
        >
          <LockOutlined style={{ marginRight: '8px' }} /> Change Password
        </p>
        <Divider style={{ margin: '8px 0' }} />
        <p
          className={'text-base cursor-pointer items-center text-red-500 block'}
          onClick={() => logout()}
        >
          <LogoutOutlined style={{ marginRight: '8px' }} /> Logout
        </p>
      </div>
    </div>
  );
  return (
    <>
      <div>
        <Popover placement="bottomRight" content={content} trigger="click">
          <Avatar
            style={{ backgroundColor: '#A23231' }}
            size="large"
            icon={<UserOutlined />}
          />
        </Popover>
      </div>

      <ResetPassword
        visible={isModalVisible}
        onClose={handleCloseResetPasswordModal}
      />
    </>
  );
};

export default Profile;
